module.exports = __webpack_public_path__ + "697e5b0809a8b230c036cfd2fa994da0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings_mailbox_2x.png
// module id = 142
// module chunks = 0 1 2 3 4